import { Dupla } from "../types";

/**
 * Utilitários modulares para gerenciamento e nomenclatura de equipes.
 * Mantém cada responsabilidade em seu próprio módulo/arquivo.
 */

/**
 * Extrai uma lista de nomes de jogadores não vazios de uma equipe (Dupla)
 */
export function getTeamPlayersArray(dupla: Dupla): string[] {
  return [
    dupla.player1,
    dupla.player2,
    dupla.player3,
    dupla.player4,
    dupla.player5,
    dupla.player6,
    dupla.player7,
    dupla.player8,
    dupla.player9,
    dupla.player10,
    dupla.player11,
    dupla.player12,
    dupla.player13,
    dupla.player14,
    dupla.player15,
  ]
    .filter(Boolean)
    .map((p) => (p as string).trim())
    .filter(Boolean);
}

/**
 * Gera nome padrão de equipe numerada (Ex: "Time 1", "Time 2")
 */
export function formatTeamName(number: number, rating?: number | string): string {
  if (rating !== undefined && rating !== null && rating !== "") {
    return `Time ${number} (⭐${rating})`;
  }
  return `Time ${number}`;
}

/**
 * Cria um objeto Dupla padronizado a partir de uma lista de nomes
 */
export function createTeamFromPlayers(
  id: string,
  name: string,
  players: string[],
  isAutoCreated = false
): Dupla {
  return {
    id,
    name,
    player1: players[0] || "",
    player2: players[1] || "",
    player3: players[2] || undefined,
    player4: players[3] || undefined,
    player5: players[4] || undefined,
    player6: players[5] || undefined,
    player7: players[6] || undefined,
    player8: players[7] || undefined,
    player9: players[8] || undefined,
    player10: players[9] || undefined,
    player11: players[10] || undefined,
    player12: players[11] || undefined,
    player13: players[12] || undefined,
    player14: players[13] || undefined,
    player15: players[14] || undefined,
    isAutoCreated,
    createdAt: Date.now(),
  };
}

/**
 * Verifica se uma equipe está incompleta em relação ao tamanho exigido pelo jogo
 */
export function isIncompleteTeam(dupla: Dupla, targetTeamSize: number): boolean {
  const count = getTeamPlayersArray(dupla).length;
  return count > 0 && count < targetTeamSize;
}
